import { rem } from 'polished'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import { getThemeClassName } from 'lib/theme/themeUtils'
import Group from 'components/utils/Group'

const TileLoadingBox = styled(LoadingBox)`
  width: ${rem(300)};
  height: ${rem(115)};

  ${mediaQueryUp.tablet} {
    width: ${rem(560)};
    height: ${rem(160)};
  }
`

const SubHeadingLoadingBox = styled(LoadingBox)`
  width: ${rem(280)};
  height: ${rem(16)};
`

const EndDateLoadingBox = styled(LoadingBox)`
  width: ${rem(140)};
  height: ${rem(16)};
`

function DealsTileSkeleton() {
  return <LayoutContainer>
    <CardCarousel
      snap="start"
      className={getThemeClassName({ desktop: 'default' })}
    >
      {Array.from({ length: 3 }).map((_, index) => <Group direction="vertical" gap={4} key={index}>
        <TileLoadingBox />
        <Group direction="vertical" gap={4}>
          <SubHeadingLoadingBox />
          <EndDateLoadingBox />
        </Group>
      </Group>)}
    </CardCarousel>
  </LayoutContainer>
}

export default DealsTileSkeleton
